import React from 'react';

import {Avatar, Icon} from '@gravity-ui/uikit';

import {block} from '../../../cn';
import {InviteeDropdownAvatarProps} from '../UserDropdownAvatar';
import {getEmptyUserAvatar} from '../helpers';

import timeIcon from '../../../../../assets/icons/time.svg';

const b = block('user-dropdown-avatar');

export const InviteeAvatar = (props: InviteeDropdownAvatarProps) => {
    const {invitee, size = 'm', title} = props;

    return (
        <React.Fragment>
            <Avatar
                className={b('avatar')}
                title={title}
                size={size}
                imgUrl={getEmptyUserAvatar(size)}
            />
            <Icon data={timeIcon} className={b('icon', {invitee})} />
        </React.Fragment>
    );
};
